import { checkIsSplitShippedToInventory } from './is-item-split-shipped';
export const isOrderSplitShipped = ({
  items,
  isSplitShipped
}) => {
  return isSplitShipped || items.some(checkIsSplitShippedToInventory);
};
export const hasSplitShippedItems = items => {
  return items.some(checkIsSplitShippedToInventory);
};